import {Box} from '@mui/material';
import {useRef} from 'react';

interface Props {
  currentTime: number;
  duration: number;
  buffered: number;
  onSeek: (time: number) => void;
}

const AurVideoProgress = ({currentTime, duration, buffered, onSeek}: Props) => {
  const trackRef = useRef<HTMLDivElement>(null);

  const playedPercent = duration > 0 ? (currentTime / duration) * 100 : 0;

  const bufferedPercent = duration > 0 ? (buffered / duration) * 100 : 0;

  const updatePosition = (clientX: number) => {
    if (!trackRef.current || duration === 0) return;

    const rect = trackRef.current.getBoundingClientRect();

    const percent = Math.min(
      Math.max((clientX - rect.left) / rect.width, 0),
      1
    );

    onSeek(percent * duration);
  };

  return (
    <Box
      ref={trackRef}
      className="aur-video-progress"
      data-testid="aur-video-progress"
      onClick={(e) => updatePosition(e.clientX)}
    >
      <Box className="track" data-testid="aur-video-progress-track" />

      <Box
        className="buffered"
        data-testid="aur-video-progress-buffered"
        style={{width: `${bufferedPercent}%`}}
      />

      <Box
        className="played"
        data-testid="aur-video-progress-played"
        style={{width: `${playedPercent}%`}}
      />
    </Box>
  );
};

export default AurVideoProgress;
